module.exports = __webpack_public_path__ + "img/down_caret_silver_grey.dbc5a886.svg";